// extracted by mini-css-extract-plugin
export var dropdown = "_r3-0";
export var imageWrapper = "_r3-3";
export var itemNameContainer = "_r3-1";
export var productImage = "_r3-2";
export var spinnerWrapper = "_r3-4";